/*
 *
 * LanguageToggle
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createSelector } from 'reselect';

import Toggle from 'components/Toggle';
import Wrapper from './Wrapper';
import messages from './messages';
import { appLocales } from '../../i18n';
import { changeLocale } from '../LanguageProvider/actions';
import { clearError } from '../App/actions';
import { makeSelectLocale } from '../LanguageProvider/selectors';

export class LocaleToggle extends React.PureComponent {
  getAvailableLocales() {
    if (typeof VARS !== 'undefined' && VARS.REACT_APP_LOCALE) {
      try {
        let localeConfig = VARS.REACT_APP_LOCALE;

        if (typeof localeConfig === 'string') {
          localeConfig = JSON.parse(localeConfig);
        }

        if (localeConfig && localeConfig.locales && Array.isArray(localeConfig.locales)) {
          return localeConfig.locales;
        }
      } catch (error) {
        console.warn('Error parsing REACT_APP_LOCALE config:', error);
      }
    }

    return appLocales;
  }

  shouldShowToggle() {
    const availableLocales = this.getAvailableLocales();
    return availableLocales && availableLocales.length > 1;
  }

  render() {
    if (!this.shouldShowToggle()) {
      return null;
    }

    const availableLocales = this.getAvailableLocales();
    return (
      <Wrapper>
        <Toggle value={this.props.locale} values={availableLocales} messages={messages} onToggle={this.props.onLocaleToggle} />
      </Wrapper>
    );
  }
}

LocaleToggle.propTypes = {
  onLocaleToggle: PropTypes.func,
  locale: PropTypes.string,
};

const mapStateToProps = createSelector(
  makeSelectLocale(),
  (locale) => ({ locale })
);

export function mapDispatchToProps(dispatch) {
  return {
    onLocaleToggle: (evt) => {
      const newLocale = evt && evt.target ? evt.target.value : evt;
      dispatch(clearError());
      dispatch(changeLocale(newLocale));
    },
    dispatch,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(LocaleToggle);



// WEBPACK FOOTER //
// ./app/containers/LocaleToggle/index.js